import React from 'react';
import { Cell, Pie, PieChart, Tooltip } from 'recharts';
import Legend from './components/Legend/Legend';
import { colors as colorsConst } from './constants';
import styles from './PieCard.module.scss';

const PieCard = ({
  data,
  colors = colorsConst,
  onItemClick,
  isActiveItem,
  renderContent,
  valueKey = 'value',
}) => {
  return (
    <div className={styles.chartContent}>
      <PieChart width={140} height={140}>
        <Tooltip />
        <Pie
          data={data}
          dataKey={valueKey}
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={35}
          outerRadius={70}
          fill="#82ca9d"
        >
          {data.map((_, index) => (
            <Cell key={index} fill={colors[index % colors.length]} />
          ))}
        </Pie>
      </PieChart>
      <Legend
        colors={colors}
        onItemClick={onItemClick}
        isActiveItem={isActiveItem}
        data={data}
        renderContent={renderContent}
      />
    </div>
  );
};

export default PieCard;
